import {
  useEffect, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import telemetryActions from '@state/telemetry/actions';

function useEnergyData() {

  const dispatch = useDispatch();
  const [infoEnvironmentData, setInfoEnvironmentData] = useState({
    CO2: 0,
    TREES: 0,
    COAL: 0,
  });
  const [infoEnergy, setInfoEnergy] = useState({});
  const InfoEnergy = useSelector(({ telemetry: tel }) => tel.generalStatistics);
  const generalInfo = useSelector(({ telemetry: tel }) => tel.generalStatistics);
  const loadingInfoSystem = useSelector(({ telemetry }) => telemetry.loadingInfoSystem);

  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const { exportEnergy } = generalInfo;
    const data = {
      CO2: parseFloat((exportEnergy * 0.16438).toFixed(1)),
      TREES: parseFloat(((exportEnergy * 0.16438) / 200).toFixed(1)),
      COAL: parseFloat((exportEnergy * 0.16438).toFixed(1)),
    };

    setInfoEnvironmentData(data);

  }, [generalInfo]);

  // return {
  //   infoEnvironmentData,
  // };

  useEffect(() => {

    setInfoEnergy(InfoEnergy);
    dispatch(telemetryActions.setLoadingInfoSystem(false));

  }, [InfoEnergy]);

  useEffect(() => {

    setLoading(loadingInfoSystem);

  }, [loadingInfoSystem]);

  return {
    infoEnergy,
    loading,
    infoEnvironmentData,
  };

}

export default useEnergyData;
